import axios from "axios";
import {appUrls, endPoints } from "../../constants/urls";
import Cookies from "universal-cookie";

const cookies = new Cookies();

const product_account_uuid  = cookies?.get("product_account_uuid");
const auth_token  = cookies?.get("merchantAccessToken");


export const getRedirectionConsent = () => {

    // const ONBOARDING_HOST = process.env.ONBOARDING_HOST;
    return axios({
      method: "GET",
      url: `${appUrls.ORCHESTRATION_LAYER  + endPoints.GET_CONSENT(product_account_uuid)}`,
    });
  };
  
  export const postRedirectionConsent = (data) => {
    // const product_account_uuid  = cookies.get("product_account_uuid");
    // const ONBOARDING_HOST = process.env.ONBOARDING_HOST;
    return axios({
      method: "POST",
      url: `${appUrls.ORCHESTRATION_LAYER  + endPoints.CREATE_OR_UPDATE_CONSENT(product_account_uuid)}`,
      data,
    });
  };

  export const updateFinAuthParams = (user_uuid) => {
    return axios({
      method: "POST",
      url: `${process.env.PAYUFIN_REDIRECTION_URL}/redirection/lending/payubiz_redirection`,
      data: {auth_token, product_account_uuid, user_uuid },
    });
  };